export default __webpack_public_path__ + "static/media/musicnote.0ba96253.png";